module.exports = "<div class=\"root_wrapper\">\n    <menu-bar ng-show=\"$ctrl.ccaSession.activeSection.showMenu\"></menu-bar>\n    <div class=\"root_view\" ng-view autoscroll></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/frontend/modules/root/components/root/root.html
// module id = 355
// module chunks = 0